import type { MultiPrimaryItem } from '@/components/Form/FormAutocompleteField/MultiPrimaryAutocompleteField';
import type { Hcp } from '@/core/graphql/generated/types';

export const mapGlobalSpecialties = (
	src: Hcp['hcpSpecialties']
): MultiPrimaryItem[] => {
	if (!src?.length) return [];
	return src.map(s => ({
		id: s.specialty?.id ?? '',
		name: s.specialty?.name ?? '',
		isPrimary: !!s.primary
	}));
};
